import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { UserService } from 'src/app/services/user/user.service';
import { DataSharingService } from 'src/app/auth/data-sharing.service';
import { EvaluationService } from 'src/app/services/evaluation/evaluation.service';
import { Vendordata } from 'src/app/model/vendordata.model';
import { AdmindashboardService } from 'src/app/services/dashboard/admin/admindashboard.service';
import { ButtonRendererComponent } from 'src/app/button-renderer.component';
import { Button3RendererComponent } from 'src/app/button3-renderer.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-admindashboard',
  templateUrl: './admindashboard.component.html',
  styleUrls: ['./admindashboard.component.css']
})
export class AdmindashboardComponent implements OnInit {

  ID: string;
  ProjectName: string;
  ClientName: string;
  addCommentBool1: boolean = false;
  addCommentBool2: boolean = false;
  ProjectDescription: string;
  //evaluationData : Vendordata;
  dataLog: any;
  data: Vendordata;
  evaluationDataAny: any;
  PurchaseOrderData: any;
  NewVendors: any;
  MessageCount: any;
  dataNew: any;
  myDashboardProjectID: string;
  rowData: any;
  addCommentBool: boolean = false;
  rowDataNew: any;
  pagination = true;
  rowDataNew1: any;
  paginationPageSize = 15;
  private gridApi;
  private gridColumnApi;
  columnDefs = [
    { headerName: '', field: '', width: 50, headerCheckboxSelection: true, checkboxSelection: true, minWidth: 40 },
    {
      headerName: 'Actions',
      minWidth: 110,
      cellRenderer: 'button3Renderer',
      cellRendererParams: {
        onClick: this.actionClick.bind(this),
      },
    },
    { headerName: "Project ID", field: "projectID", filter: true, sortable: true, resizable: true },
    { headerName: "Project", field: "projectName", filter: true, sortable: true, resizable: true },
    { headerName: "Client", field: "clientName", filter: true, sortable: true, resizable: true },
    { headerName: "Mode", field: "projectMode", filter: true, sortable: true, resizable: true },
    { headerName: "Actual Target", field: "target", filter: true, sortable: true, resizable: true },
    { headerName: "Optimistic Count", field: "optimisticCount", filter: true, sortable: true, resizable: true },
    { headerName: "Overall Target", field: "totalTarget", filter: true, sortable: true, resizable: true },
    { headerName: "Completes", field: "totalComplete", filter: true, sortable: true, resizable: true },
    { headerName: "Left Over", field: "leftOver", filter: true, sortable: true, resizable: true },
    { headerName: "In Progress", field: "inprogress", filter: true, sortable: true, resizable: true },
    { headerName: "Incident Rate(%)", field: "incidentRate", filter: true, sortable: true, resizable: true },
    { headerName: "Terminate", field: "totalTerminate", filter: true, sortable: true, resizable: true },
    { headerName: "Quota Full", field: "totalQuotaFull", filter: true, sortable: true, resizable: true },
    { headerName: "QC Reject", field: "totalQCReject", filter: true, sortable: true, resizable: true },
    {
      headerName: 'Delete',
      cellRenderer: 'buttonRenderer',
      cellRendererParams: {
        onClick: this.deleteSpecificProject.bind(this),
        label: 'Delete'
      },
    },
  ];

  columnDefsNew = [
    { headerName: "Country Name", field: "country", filter: true, sortable: true, resizable: true },
    { headerName: "Language", field: "language", filter: true, sortable: true, resizable: true },
    { headerName: "Actual Target", field: "target", filter: true, sortable: true, resizable: true },
    { headerName: "Optimistic Count", field: "optimisticCount", filter: true, sortable: true, resizable: true },
    { headerName: "Overall Target", field: "totalTarget", filter: true, sortable: true, resizable: true },
    { headerName: "Overall Target", field: "totalTarget", filter: true, sortable: true, resizable: true },
    { headerName: "Complete", field: "totalComplete", filter: true, sortable: true, resizable: true },
    { headerName: "Left Over", field: "leftOver", filter: true, sortable: true, resizable: true },
    { headerName: "InProgress", field: "inProgress", filter: true, sortable: true, resizable: true },
    { headerName: "Incident Rate", field: "incidentRate", filter: true, sortable: true, resizable: true },
    { headerName: "Terminate", field: "totalTerminate", filter: true, sortable: true, resizable: true },
    { headerName: "Quota Full", field: "totalQuotaFull", filter: true, sortable: true, resizable: true },
    { headerName: "QC Reject", field: "totalQCReject", filter: true, sortable: true, resizable: true },

  ];

  columnDefsNew1 = [
    { headerName: "Project Mode", field: "projectMode", filter: true, sortable: true, resizable: true },
    { headerName: "Finger Print", field: "isFingerPrintEnabled", filter: true, sortable: true, resizable: true },
    { headerName: "IP Security", field: "isIPEnabled", filter: true, sortable: true, resizable: true },
    { headerName: "GEO IP Locaion", field: "isGeoIPLocationEnabled", filter: true, sortable: true, resizable: true },
    { headerName: "Custom Page", field: "isCustomPageEnabled", filter: true, sortable: true, resizable: true },
    { headerName: "Captcha", field: "isCaptcha", filter: true, sortable: true, resizable: true },
    { headerName: "Questionnaire", field: "isQuestionnaire", filter: true, sortable: true, resizable: true },
    
    //{ headerName: "Mobile", field: "isMobile", filter: true, sortable: true, resizable: true },

    { headerName: "Device", field: "isMobile", filter: true, sortable: true, resizable: true },
    { headerName: "RD Check", field: "isRDEnabled", filter: true, sortable: true, resizable: true },
    { headerName: "Activity", field: "isActivityEnabled", filter: true, sortable: true, resizable: true },
    
    //{ headerName: "Custom Page Message", field: "customPageMessage", filter: true, sortable: true,resizable: true},
    { headerName: "Update On", field: "updateOn", filter: true, sortable: true, resizable: true },
    { headerName: "Updated By", field: "updatedBy", filter: true, sortable: true, resizable: true },
  ];
  autoGroupColumnDef = {
    headerName: 'Select',
    field: 'select',
    minWidth: 250,
    cellRenderer: 'agGroupCellRenderer',
    cellRendererParams: { checkbox: true },
  };
  defaultColDef = {
    flex: 1,
    minWidth: 100,
  };
  rowSelection = 'multiple';
  frameworkComponents: any


  constructor(private router: Router, private userService: UserService, private toastr: ToastrService,
    private dataSharingService: DataSharingService, private evaluationService: EvaluationService, private adminDashboardService: AdmindashboardService) {
    this.frameworkComponents = {
      buttonRenderer: ButtonRendererComponent,
      button3Renderer: Button3RendererComponent,
    }
  }

  ngOnInit() {
    debugger;
    this.adminDashboardService.getPurchaseOrders().subscribe(
      (data) => {
        this.PurchaseOrderData = data;
        console.log(this.PurchaseOrderData);
      }
    )
    this.adminDashboardService.getNewVendors().subscribe(
      (data) => {
        this.NewVendors = data;
        console.log(this.NewVendors);
      }
    )
    this.adminDashboardService.getMessageCount().subscribe(
      (data) => {
        this.MessageCount = data;
        console.log("Message count" + this.MessageCount);
      }
    )


    this.evaluationService.getVendorsForEvaluation().subscribe(
      (data) => {
        this.evaluationDataAny = data;
        for (var i = 0; i < this.evaluationDataAny.length; i++) {
          this.evaluationDataAny[i].leftOver = this.evaluationDataAny[i].totalTarget - this.evaluationDataAny[i].totalComplete - this.evaluationDataAny[i].optimisticCount
        }
        //this.evaluationData = this.evaluationDataAny;
        this.data = this.evaluationDataAny;
        this.rowData = this.data;
        console.log(this.data);
      }
    )

  }
  searchProject(keyword) {
    this.userService.searchProjectFromMyDashboard(keyword).subscribe(
      (data) => {
        this.dataNew = data;
        for (var i = 0; i < this.dataNew.length; i++) {
          this.dataNew[i].leftOver = this.dataNew[i].totalTarget - this.dataNew[i].totalComplete - this.dataNew[i].optimisticCount
        }
        this.data = this.dataNew;
        this.rowData = this.data;
      }
    );
  }

  deleteSpecificProject(params) {
    debugger;

    var result = confirm("Are you sure you want to delete ?");
    if (result) {
      this.userService.deleteSpecificProject(params.data.projectID).subscribe(
        (data) => {
          if (data == true) {
            this.toastr.success("Project Deleted from Dashboard", '', { progressBar: true });
            this.evaluationService.getVendorsForEvaluation().subscribe(
              (data) => {
                this.evaluationDataAny = data;
                for (var i = 0; i < this.evaluationDataAny.length; i++) {
                  this.evaluationDataAny[i].leftOver = this.evaluationDataAny[i].totalTarget - this.evaluationDataAny[i].totalComplete - this.evaluationDataAny[i].optimisticCount
                }
                //this.evaluationData = this.evaluationDataAny;
                this.data = this.evaluationDataAny;
                this.rowData = this.evaluationDataAny;;
                console.log(this.data);
              }
            )
          }
          else {

          }
        }
      )
    }

  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onBtnExport() {
    debugger;
    let selectedNodes = this.gridApi.getSelectedNodes();
    if (selectedNodes.length > 0) {
      var params = {
        onlySelected: true,
      };
      this.gridApi.exportDataAsCsv(params);
      this.gridApi.deselectAll();
    }

    else {
      this.toastr.warning("Select atleast one checkbox to export", '', { progressBar: true });
      //alert("Select atleast one checkbox to export");
    }
  }

  actionClick(param) {
    debugger;
    var id = param.event.srcElement['id'];
    var projectId = param.rowData.projectID;
    var projectname = param.rowData.projectName;
    var clientname = param.rowData.clientName;
    var projectdesc = param.rowData.projectDescription;
    if (id == "view") {
      this.router.navigate(['/viewprojectdetails/' + projectId]);
    }
    else if (id == "addcomment") {
      this.addCommentBool = true;
      this.addCommentBool1 = false;
      this.addCommentBool2 = false;
      $("#Modal").css("width", "77%");
      this.ID = projectId;
      $("#myModal").show();
    }
    else if (id == "projectinfo") {
      this.addCommentBool = false;
      this.addCommentBool2 = false;
      this.addCommentBool1 = true;
      this.ID = projectId;
      this.ProjectName = projectname;
      this.ClientName = clientname;
      this.ProjectDescription = projectdesc;
      this.userService.getProjectCalculationDetails(this.ID).subscribe(
        (data) => {
          if (data != null) {
            // console.log(data);
            this.rowDataNew = data;
            for (var i = 0; i < this.rowDataNew.length; i++) {
              this.rowDataNew[i].leftOver = this.rowDataNew[i].totalTarget - this.rowDataNew[i].totalComplete - this.rowDataNew[i].optimisticCount
            }
          }
          else {
            this.rowDataNew = "";
          }
        }
      );
      $("#Modal").css("width", "140%");
      $("#myModal").show();
    }

    else if (id == "projectlog") {
      this.addCommentBool = false;
      this.addCommentBool1 = false;
      this.addCommentBool2 = true;
      this.ID = projectId;
      this.ProjectName = projectname;
      this.ClientName = clientname;
      this.ProjectDescription = projectdesc;

      this.userService.getProjectLog(this.ID).subscribe(
        (data) => {
          console.log(data);
          if (data != null && data != undefined) {
             this.dataLog =data;
            // for(var i =0; i<this.dataLog.length; i++)
            // {
            //   this.dataLog[i].customPageMessage = data[i].customPageMessage.replace(/<[^>]*>/g, '');
            // }
            for (var i = 0; i < this.dataLog.length; i++) {
              if (this.dataLog[i].isMobile == 0) {
                this.dataLog[i].isMobile = "Desktop"
              }
              else if (this.dataLog[i].isMobile == 1) {
                this.dataLog[i].isMobile = "Mobile"
              }
              else if (this.dataLog[i].isMobile == 2) {
                this.dataLog[i].isMobile = "Both"
              }
            }
            this.rowDataNew1 = this.dataLog;

          }
          else {
            this.rowDataNew1 = "";
          }
        });
      $("#Modal").css("width", "140%");
      $("#myModal").show();
    }
    else {}
  }

  closeDialog() {
    $("#myModal").hide();
  }


}
